define('responsive-gameday-tracking/responsive-gameday-tracking',['require','./src/js/GamedayTracking'],function(require) {
    return require('./src/js/GamedayTracking');
});
